module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY4.42821a4c.jpg";